import { pseudoDescriptors } from "./pseudoDescriptors";
const mergeProps = (a, b, inverseShorthands) => {
  const out = {};
  for (const key in a) {
    mergeProp(out, a, b, key, inverseShorthands);
  }
  if (b) {
    for (const key in b) {
      mergeProp(out, b, void 0, key, inverseShorthands);
    }
  }
  return out;
};
function mergeProp(out, a, b, key, inverseShorthands) {
  const shorthand = (inverseShorthands == null ? void 0 : inverseShorthands[key]) || null;
  if (b && (key in b || shorthand && shorthand in b)) {
    return;
  }
  const val = a[key];
  if (key in pseudoDescriptors) {
    out[key] = {
      ...out[key],
      ...val
    };
    return;
  }
  out[shorthand || key] = val;
}
export {
  mergeProps
};
//# sourceMappingURL=mergeProps.js.map
